import globalState from './state/globalState';
import { AppContainer } from './layout';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'styles/css/ag_theme.scss';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DeclarationListPrintPage from './components/print/DeclarationListPrintPage';
import { useRecoilState } from 'recoil';
import UserApi from './api/UserApi';

function App() {
  const [auth, setAuth] = useRecoilState(globalState);
  const { pathname, search, state } = useLocation();

//   useEffect(() => {
//     const validateToken = async () => {
//       // 토큰 검사
//       const token = auth.UserInformation.token;

//       // 토큰이 없으면 메인페이지로 이동
//       if (!token) {
//         window.location.href = '/main';
//         return;
//       }

//       try {
//         // 토큰 있으면 유효성 검사
//         const response = await UserApi.ValidateToken('/validate-token', token);

//         // 유효성 검사 패스하면 return
//         if (response.data.result.is_valid) {
//           setAuth({ ...auth, isLogin: true });
//           return;
//         }
//       } catch (error) {
//         alert('로그인 세션 정보가 만료되었습니다. 메인페이지로 이동합니다.');
//       }

//       // 유효성 검사 패스못하면 메인페이지로 이동
//       // localStorage.removeItem('login-token');
//       setAuth({ ...auth, isLogin: false });
//       window.location.href = '/main';
//     };

//     const isDev = process.env.REACT_APP_OP_ENV === 'production';

//     if (isDev) {
//       validateToken();
//     }
//   }, [pathname]);

  if (pathname.includes('/print/declarator-print')) {
    return <DeclarationListPrintPage />;
  }

  return <AppContainer />;
  // for developing
  // return <>{auth.isLogin ? <>main</> : <>login</>}</>;
}

export default App;
